import { AutoComplete } from 'antd'
import { useState } from 'react'
import { search } from 'src/api/user'

interface UserNameAutoCompleteWithIdProps {
  appendSearchForm: (values: any) => void
  updateCriteria: (values: any) => void
}

export const UserNameAutoCompleteWithId = ({
  appendSearchForm,
  updateCriteria,
}: UserNameAutoCompleteWithIdProps) => {
  const [options, setOptions] = useState<
    { label: string; value: string; userId: string }[]
  >([])
  const [searchText, setSearchText] = useState('')

  const handleSearch = async (value: string) => {
    setSearchText(value)
    if (value.trim()) {
      try {
        const result = await search({ username: value })
        if (result?.data?.length) {
          const suggestions = result.data.map((user: any) => ({
            label: user.userName,
            value: user.userName,
            userId: user.userId,
          }))
          setOptions(suggestions)
        } else {
          setOptions([])
        }
      } catch (error) {
        console.error('Error fetching users:', error)
        setOptions([])
      }
    } else {
      setOptions([])
    }
  }

  const handleSelect = (value: string, option: any) => {
    updateCriteria({
      userId: option.userId,
    })
    appendSearchForm({
      userId: option.userId,
    })
    setSearchText(value)
  }

  const handleChange = (value: string) => {
    setSearchText(value)
    if (!value) {
      appendSearchForm({ userId: undefined })
      updateCriteria({
        userId: undefined,
      })
    }
  }

  return (
    <AutoComplete
      options={options}
      onSearch={handleSearch}
      onSelect={handleSelect}
      onChange={handleChange}
      value={searchText}
      allowClear
      placeholder="User Name"
      className="search-input"
      style={{ width: '100%' }}
    />
  )
}
